import { SetNewPasswordComponent } from "@forwardflow/components/SetNewPassword";

const SetNewPassword = () => {
  return <SetNewPasswordComponent />;
};

export default SetNewPassword;
